/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
import axios from "axios";
import store from "redux-react/store";

/**
 * Get a signed URL to upload a file in S3
 * @param {*} file - File to upload
 * @param {*} extra - Extra data to send to the backend
 * @param {*} context - Context to send to the backend, usually the path where the file will be stored
 * @returns
 */
export async function getSignedUrl(file, extra = {}, context = null) {
	try {
		const endPoint = process.env.REACT_APP_AMBACK;

		let user = store.getState().user;
		let assistantID = extra?.publicBucket ? "public" : store.getState().profile.assistantID;

		const axiosCall = await axios(endPoint + "/api/v1/s3/uploadSignedUrl", {
			headers: {
				Authorization: `Bearer ${user.token}`,
				UserEmail: user.email
			},
			method: "POST",
			data: {
				assistantID,
				size: file.size,
				fileName: file.name,
				contentType: file.type,
				...extra,
				context
			}
		});

		return {
			success: true,
			result: axiosCall.data
		};
	} catch (error) {
		return {
			success: false,
			error
		};
	}
}

/**
 * Upload a file in S3, need a signed URL
 * @param {*} signedURL
 * @param {*} file
 * @returns
 */
export async function uploadToSignedUrl(signedURL, file) {
	try {
		await axios.put(signedURL, file, {
			headers: {
				"Content-Type": file.type
			}
		});
		return {
			success: true
		};
	} catch (error) {
		return {
			success: false,
			error
		};
	}
}

/**
 * Delete a file from S3 : two ways :
 * - By key : key is the complete path to the file in the bucket
 * - By path and fileName : path is the folder where the file is stored, fileName is the name of the file
 *
 * Prefer using delete by key.
 *
 * @param {*} param0
 * @returns
 */
export async function deleteFileFromPath({ key, path, fileName, publicBucket = false }) {
	try {
		const endPoint = process.env.REACT_APP_AMBACK;

		let user = store.getState().user;
		let assistantID = publicBucket ? "public" : store.getState().profile.assistantID;

		const axiosCall = await axios(endPoint + "/api/v1/s3/deleteFile", {
			headers: {
				Authorization: `Bearer ${user.token}`,
				UserEmail: user.email
			},
			method: "POST",
			data: {
				assistantID,
				// Key infos
				key,
				// Path infos
				path,
				fileName
			}
		});

		return {
			success: true,
			result: axiosCall.data
		};
	} catch (error) {
		return {
			success: false,
			error
		};
	}
}

export async function uploadFileToS3(
	answerItemFile,
	answerItemID,
	type,
	langue,
	publicBucket = false
) {
	try {
		// 1- Get the signed URL
		const { success, error, result } = await getSignedUrl(
			answerItemFile,
			{
				type,
				answerItemID,
				langue,
				publicBucket
			},
			publicBucket ? "public" : "answerItem"
		);

		if (!success) {
			return null;
		}

		const signedUrl = result.signedUrl;
		const fileObject = result.fileObject;

		// 2- Upload the file
		const uploadedFile = await uploadToSignedUrl(signedUrl, answerItemFile);

		return { uploadedFile, fileObject };
	} catch (error) {
		// error
		return null;
	}
}

/**
 * Upload a file from a URL directly to S3 via the backend API
 * @param {string} url - The URL of the file to fetch and upload
 * @param {string} answerItemID - The unique identifier for the answer item
 * @param {string} type - The type of file (e.g., "image", "document")
 * @param {string} langue - The language code for the file
 * @param {string|null} fileName - Optional custom file name, defaults to null
 * @returns {object} An object with success flag and result/error properties
 * @example
 * const result = await uploadFileFromUrlToS3('https://example.com/image.jpg', 'ans_123', 'image', 'fr', 'custom.jpg');
 * if (result.success) {
 *   console.log(result.result); // { url, key, ... }
 * }
 */
export async function uploadFileFromUrlToS3(
	url,
	answerItemID,
	type,
	langue,
	fileName = null,
	publicBucket = false
) {
	try {
		const endPoint = process.env.REACT_APP_AMBACK;

		let user = store.getState().user;
		let assistantID = publicBucket ? "public" : store.getState().profile.assistantID;

		const axiosCall = await axios(endPoint + "/api/v1/s3/uploadFileFromUrl", {
			headers: {
				Authorization: `Bearer ${user.token}`,
				UserEmail: user.email
			},
			method: "POST",
			data: {
				assistantID,
				url,
				type,
				answerItemID,
				langue,
				fileName,
				context: publicBucket ? "public" : "answerItem"
			}
		});

		return {
			success: true,
			result: axiosCall.data
		};
	} catch (error) {
		return {
			success: false,
			error
		};
	}
}
